import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { path: "/", label: "Home" },
  { path: "/rsvp", label: "RSVP" },
  { path: "/foto-ricordo", label: "Foto Ricordo" },
  { path: "/lista-nozze", label: "Lista Nozze" },
];

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <nav
      data-testid="main-navigation"
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
      style={{
        background: isHome
          ? "rgba(255, 253, 248, 0.85)"
          : "rgba(255, 253, 248, 0.97)",
        backdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(197, 165, 114, 0.2)",
      }}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="font-serif text-xl tracking-tight"
          style={{ color: "#2C2C2C" }}
          data-testid="nav-logo"
        >
          M <span className="text-gold">&</span> M
        </Link>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium tracking-wide transition-colors duration-300 hover:text-sage relative"
              style={{
                color:
                  location.pathname === link.path ? "#8B9A6B" : "#2C2C2C",
              }}
            >
              {link.label}
              {location.pathname === link.path && (
                <span
                  className="absolute -bottom-1 left-0 right-0 h-0.5"
                  style={{ backgroundColor: "#C5A572" }}
                />
              )}
            </Link>
          ))}
        </div>

        {/* Mobile menu button */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden touch-target flex items-center justify-center"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? (
            <X size={24} color="#2C2C2C" />
          ) : (
            <Menu size={24} color="#2C2C2C" />
          )}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden animate-fade-in"
          style={{ backgroundColor: "rgba(255, 253, 248, 0.98)" }}
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-lg font-medium py-2 transition-colors duration-300"
                style={{
                  color:
                    location.pathname === link.path ? "#8B9A6B" : "#2C2C2C",
                }}
                onClick={() => setOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
